import { useEffect, useState } from 'react'

interface ConfettiProps {
    isActive: boolean
    duration?: number
}

interface ConfettiPiece {
    id: number
    x: number
    y: number
    color: string
    size: number
    rotation: number
    velocityX: number
    velocityY: number
    rotationSpeed: number
}

const colors = [
    '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7',
    '#DDA0DD', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E9'
]

export default function Confetti({ isActive, duration = 3000 }: ConfettiProps) {
    const [confettiPieces, setConfettiPieces] = useState<ConfettiPiece[]>([])

    useEffect(() => {
        if (!isActive) {
            setConfettiPieces([])
            return
        }

        // Criar confetes
        const pieces: ConfettiPiece[] = []
        for (let i = 0; i < 150; i++) {
            pieces.push({
                id: i,
                x: Math.random() * window.innerWidth,
                y: -10,
                color: colors[Math.floor(Math.random() * colors.length)],
                size: Math.random() * 8 + 4,
                rotation: Math.random() * 360,
                velocityX: (Math.random() - 0.5) * 4,
                velocityY: Math.random() * 3 + 2,
                rotationSpeed: (Math.random() - 0.5) * 10
            })
        }

        setConfettiPieces(pieces)

        // Animar confetes
        const startTime = Date.now()
        const animate = () => {
            const elapsed = Date.now() - startTime

            if (elapsed < duration) {
                setConfettiPieces(prev =>
                    prev.map(piece => ({
                        ...piece,
                        x: piece.x + piece.velocityX,
                        y: piece.y + piece.velocityY,
                        rotation: piece.rotation + piece.rotationSpeed,
                        velocityY: piece.velocityY + 0.1 // gravidade
                    })).filter(piece => piece.y < window.innerHeight + 50)
                )
                requestAnimationFrame(animate)
            } else {
                setConfettiPieces([])
            }
        }

        requestAnimationFrame(animate)
    }, [isActive, duration])

    if (!isActive || confettiPieces.length === 0) return null

    return (
        <div className="fixed inset-0 pointer-events-none z-50 overflow-hidden">
            {confettiPieces.map(piece => (
                <div
                    key={piece.id}
                    className="absolute"
                    style={{
                        left: piece.x,
                        top: piece.y,
                        width: piece.size,
                        height: piece.size,
                        backgroundColor: piece.color,
                        transform: `rotate(${piece.rotation}deg)`,
                        borderRadius: '50%'
                    }}
                />
            ))}
        </div>
    )
}


